export var VideoType;
(function (VideoType) {
    VideoType[VideoType["Ezviz"] = 0] = "Ezviz";
    VideoType[VideoType["LeChange"] = 1] = "LeChange";
})(VideoType || (VideoType = {}));
